import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e27d053"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4 is-flex is-align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-size-4 mb-0" }, " Shared Dimensions ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "panel-block is-flex is-justify-content-center" }
const _hoisted_7 = {
  key: 0,
  class: "panel"
}
const _hoisted_8 = { class: "is-flex-grow-1 is-flex is-justify-content-space-between is-flex-direction-column" }
const _hoisted_9 = { class: "has-text-weight-bold" }
const _hoisted_10 = { class: "abbreviations is-size-7" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "has-text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_language_select = _resolveComponent("language-select")!
  const _component_cc_hydra_operation_form = _resolveComponent("cc-hydra-operation-form")!
  const _component_term_with_language = _resolveComponent("term-with-language")!
  const _component_shared_dimension_tags = _resolveComponent("shared-dimension-tags")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_pagination = _resolveComponent("o-pagination")!
  const _component_loading_block = _resolveComponent("loading-block")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_page_content = _resolveComponent("page-content")!

  return (_openBlock(), _createBlock(_component_page_content, { class: "container-narrow" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (_ctx.collection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_hydra_operation_button, {
                operation: _ctx.collection.actions.create,
                to: { name: 'SharedDimensionCreate' },
                variant: "default",
                size: "normal",
                label: _ctx.collection.actions.create.title
              }, null, 8, ["operation", "label"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_language_select, {
          style: {"margin-left":"15px"},
          "selected-language": _ctx.selectedLanguage,
          onLanguageSelected: _ctx.selectLanguage
        }, null, 8, ["selected-language", "onLanguageSelected"])
      ]),
      (_ctx.collection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_cc_hydra_operation_form, {
                inline: "",
                clearable: "",
                ".operation": _ctx.operation,
                ".resource": _ctx.searchParams,
                ".shape": _ctx.shape,
                onSubmit: _ctx.onSearch,
                "submit-when-cleared": ""
              }, null, 8, [".operation", ".resource", ".shape", "onSubmit"])
            ]),
            (_ctx.dimensions.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (dimension) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: dimension.id.value,
                      to: { name: 'SharedDimension', params: { id: dimension.clientPath } },
                      class: "panel-block"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_term_with_language, {
                              values: dimension.names,
                              "selected-language": _ctx.selectedLanguage
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", null, " <" + _toDisplayString(dimension.id.value) + "> ", 1),
                                _createTextVNode(),
                                _createElementVNode("small", null, "(No translation for " + _toDisplayString(_ctx.selectedLanguage) + ")", 1)
                              ]),
                              _: 2
                            }, 1032, ["values", "selected-language"])
                          ]),
                          _createElementVNode("p", _hoisted_10, [
                            _createVNode(_component_term_with_language, {
                              values: dimension.abbreviation,
                              "selected-language": _ctx.selectedLanguage
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 2
                            }, 1032, ["values", "selected-language"])
                          ])
                        ]),
                        _createVNode(_component_shared_dimension_tags, { dimension: dimension }, null, 8, ["dimension"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128)),
                  _createVNode(_component_o_pagination, {
                    simple: "",
                    current: _ctx.page,
                    total: _ctx.collection.totalItems,
                    "per-page": _ctx.pageSize,
                    onChange: _ctx.fetchPage
                  }, null, 8, ["current", "total", "per-page", "onChange"])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, " No shared dimension yet "))
          ]))
        : (_openBlock(), _createBlock(_component_loading_block, { key: 1 })),
      (_ctx.collection)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}